import React, { useState } from "react"

import dayjs from "dayjs"
import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { ValueFormat } from "~tailwindui/types/enums"

import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import formatValue from "src/formatValue"

import DataDateRange from "components/OrganizationAdmin/components/DataDateRange"
import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"

const SchoolsPage = () => {
  const history = useHistory()
  const [page, setPage] = useState(1)

  const defaultStartingAt = dayjs().startOf("year")
  const defaultEndingAt = dayjs()
  const [startingAt, setStartingAt] = useState(defaultStartingAt)
  const [endingAt, setEndingAt] = useState(defaultEndingAt)

  const [result] = useQuery({
    query: schoolsQuery,
    variables: { page, startingAt, endingAt },
  })

  return (
    <>
      <Header title="Schools" />
      <DataDateRange
        startDate={startingAt}
        setStartDate={setStartingAt}
        endDate={endingAt}
        setEndDate={setEndingAt}
      />

      <WithLoadingIndicator result={result}>
        {({ data }) => (
          <>
            <Table
              data={data.viewer.organization.schools}
              changePage={setPage}
              rowCallback={school => history.push(`/schools/${school.id}`)}
              cols={[
                { header: "Name", value: school => school.name },
                {
                  header: "Active Students",
                  value: school => school.activeStudentsCount,
                },
                {
                  header: "Active Study Groups",
                  value: school => school.activeStudyGroupsCount,
                },
                {
                  header: "Group Attendance Rate",
                  value: school =>
                    formatValue(school.groupAttendance, ValueFormat.Percent),
                },
                {
                  header: "Individual Attendance Rate",
                  value: school =>
                    formatValue(school.attendance, ValueFormat.Percent),
                },
                {
                  header: "Groups with No Shows",
                  value: school => school.noShowstudyGroupsCount,
                },
              ]}
            />
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const schoolsQuery = gql`
  query schools($page: Int!, $startingAt: DateTime!, $endingAt: DateTime!) {
    viewer {
      organization {
        schools: paginatedSchools(page: $page) {
          currentPage
          totalPages
          data {
            id
            name
            activeStudentsCount: studentsCount(
              startDate: $startingAt
              endDate: $endingAt
              active: true
            )
            activeStudyGroupsCount: studyGroupsCount(
              startDate: $startingAt
              endDate: $endingAt
              active: true
            )
            groupAttendance: attendance(
              startingAt: $startingAt
              endingAt: $endingAt
              groupRate: true
            )
            attendance(startingAt: $startingAt, endingAt: $endingAt)
            noShowstudyGroupsCount: studyGroupsCount(
              startDate: $startingAt
              endDate: $endingAt
              noShow: true
            )
          }
        }
      }
    }
  }
`

export default SchoolsPage
